import React from 'react';
import clsx from 'clsx';

import { UICarbonNumberField } from '@futrli/ui-components';

import { MAX_PERCENTAGE } from '../../../../../core/constants';
import headerStyles from '../../prediction-header-bar/prediction-header-bar.scss';

interface IncreaseDecreasePercentageProps {
  disabled?: boolean;
  onChange: (value: string) => void;
  value: string;
}

export const IncreaseDecreasePercentage = ({ disabled, onChange, value }: IncreaseDecreasePercentageProps) => (
  <UICarbonNumberField
    type="percentage"
    className={clsx(headerStyles.formInput, headerStyles.unlabelledControl)}
    disabled={disabled}
    onChange={onChange}
    value={value}
    clampMax={MAX_PERCENTAGE}
    clampMin={-MAX_PERCENTAGE}
    size="large"
  />
);
